import __var_0__ from '@stdlib/utils/define-nonenumerable-read-only-property';
import __var_1__ from '@stdlib/assert/tools/array-like-function';
import __var_2__ from '@stdlib/assert/is-safe-integer';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/**
* Test if a value is an array-like object containing only safe integers.
*
* @module @stdlib/assert/is-safe-integer-array
*
* @example
* var isSafeIntegerArray = require( '@stdlib/assert/is-safe-integer-array' );
*
* var bool = isSafeIntegerArray( [ -3.0, new Number(0.0), 2.0 ] );
* // returns true
*
* bool = isSafeIntegerArray( [ -3.0, '3.0' ] );
* // returns false
*
* @example
* var isSafeIntegerArray = require( '@stdlib/assert/is-safe-integer-array' ).primitives;
*
* var bool = isSafeIntegerArray( [ -1.0, 10.0 ] );
* // returns true
*
* bool = isSafeIntegerArray( [ -1.0, 0.0, 5.0 ] );
* // returns true
*
* bool = isSafeIntegerArray( [ -3.0, new Number(-1.0) ] );
* // returns false
*
* @example
* var isSafeIntegerArray = require( '@stdlib/assert/is-safe-integer-array' ).objects;
*
* var bool = isSafeIntegerArray( [ new Number(1.0), new Number(3.0) ] );
* // returns true
*
* bool = isSafeIntegerArray( [ -1.0, 0.0, 3.0 ] );
* // returns false
*
* bool = isSafeIntegerArray( [ 3.0, new Number(-1.0) ] );
* // returns false
*/

// MODULES //
var setReadOnly = __var_0__;
var arrayfun = __var_1__;
var isSafeInteger = __var_2__;


// MAIN //

var isSafeIntegerArray = arrayfun( isSafeInteger );
setReadOnly( isSafeIntegerArray, 'primitives', arrayfun( isSafeInteger.isPrimitive ) );
setReadOnly( isSafeIntegerArray, 'objects', arrayfun( isSafeInteger.isObject ) );


// EXPORTS //
export default isSafeIntegerArray;
